import React, {Component} from 'react';
import {HeadingSmall, ParagraphLarge} from 'baseui/typography';

class Support extends Component {
    render = () => {
        return <div>
            <HeadingSmall style={{margin: 0}}>EncLock Support</HeadingSmall>
            <ParagraphLarge>If you have any questions about EncLock please email us at: admin@myenclock.com</ParagraphLarge>
        </div>
    };
}

export default Support;
